import React, { FC, useState } from 'react'
import i18n from 'i18next'
import payMobx from '@mobx/pay/pay.mobx'
import { IMenuItemProps } from '../Bill'
import { AddGiftCardPayModal } from '@cps'
import CardItem from './CardItem'

const MenuItem: FC<IMenuItemProps> = ({ currentCard, onSelect }) => {
  const [showAddGiftCard, setShowAddGiftCard] = useState(false)

  const onNewGiftCard = async (giftCard: IGiftCardInfo) => {
    const newCard = await payMobx.addTempGiftCard(giftCard)
    setShowAddGiftCard(false)
    onSelect && onSelect('giftCard', newCard)
  }

  return (
    <>
      <li className='group'>
        <div className='group-title' onClick={() => setShowAddGiftCard(true)}>
          <img src={require('@img/payment/giftcard.png')} />
          {i18n.t('pay.addGiftCard')}
        </div>
        {payMobx.giftCards.length > 0 && (
          <ul className='card-list'>
            {payMobx.giftCards.map(x => (
              <CardItem
                key={x.id}
                card={x}
                isCurrent={currentCard && currentCard.id === x.id}
                onSelect={() => onSelect('giftCard', x)}
              />
            ))}
          </ul>
        )}
      </li>
      <AddGiftCardPayModal
        show={showAddGiftCard}
        onClose={() => setShowAddGiftCard(false)}
        onSave={onNewGiftCard}
      />
    </>
  )
}

export default MenuItem
